import config from '@/config';
import { ILang } from './type';

const list: ILang['list'] = [
    {
        tagName: 'PoE IP Cameras & NVRs',
        link: `${config.store}/poe-ip-cameras/`
    },
    {
        tagName: 'Dual-Lens Security Cameras',
        link: `${config.store}/dual-lens-cameras/`
    },
    {
        tagName: 'Video Doorbells',
        link: `${config.store}/video-doorbells/`
    },
    {
        tagName: 'WiFi Security Cameras',
        link: `${config.store}/wifi-security-cameras/`
    },
    {
        tagName: 'Battery Cameras',
        link: `${config.store}/battery-security-cameras/`
    },
    {
        tagName: 'Security Camera Systems',
        link: `${config.store}/security-camera-systems/`
    },
    {
        tagName: 'KEEN (Trail Camera)',
        link: `${config.official}/product/keen-ranger-pt/`
    },
];

const title: ILang['title'] = 'Build Your Smart and Secure Reolink Home';

export const en = {
    list,
    title
};
